import { createContext, useState, useContext, ReactNode, useEffect } from "react";
import Cookies from "js-cookie";

type AuthContextType = {
  isAuthenticated: boolean;
  token: string | null;
  login: (token: string) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  token: null,
  login: () => {},
  logout: () => {},
});

type AuthProviderProps = {
  children: ReactNode;
};
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true); // ⬅️ add loading flag

  useEffect(() => {
    const cookieToken = Cookies.get("husk.Jwttoken");
    if (cookieToken) {
      setToken(cookieToken);
      setIsAuthenticated(true);
    }
    setLoading(false); // ⬅️ done loading after token check
  }, [token]);

  const login = (token: string) => {
    Cookies.set("husk.Jwttoken", token, { expires: 1 });
    setToken(token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    Cookies.remove("husk.Jwttoken");
    Cookies.remove("husk.user");
    setToken(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return null; // or return a spinner, skeleton, etc.
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);
